import type { Statement } from '@/modules/projects/stores'

export const CUT_BY_TRIAL = 'cut_by_trial'

export interface FileRead {
  statement: Statement
  pagesRead: number
  pagesUnread: number
}

const byUploadOrder = (first: Statement, second: Statement) =>
  first.createdAt.localeCompare(second.createdAt) || first.id - second.id

// Mirrors lukita's trial walk in extract_and_enrich: files in upload order, each read whole until
// the balance runs out, and the file that crosses it is cut. Display only; the server decides.
export const planTrialRead = (
  statements: Statement[],
  pagesLeft: number,
): FileRead[] => {
  let balance = pagesLeft
  return [...statements].sort(byUploadOrder).map((statement) => {
    const pagesRead = Math.min(statement.numberOfPages, balance)
    balance -= pagesRead
    return {
      statement,
      pagesRead,
      pagesUnread: statement.numberOfPages - pagesRead,
    }
  })
}

export const totalPagesRead = (reads: FileRead[]) =>
  reads.reduce((total, read) => total + read.pagesRead, 0)

export const sumPages = (statements: Statement[]) =>
  statements.reduce((total, statement) => total + statement.numberOfPages, 0)
